<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="fechar"
    >
      <template slot="conteudo">
        <b-tabs>
          <b-tab
            no-body
            title="Dados Pessoais"
          >
            <!-- Ativo/Inativo -->
            <b-row>
              <b-form-group class="col-12 my-0 pb-0">
                <b-form-checkbox
                  v-model="form.ativo"
                  checked="true"
                  class="custom-control-primary"
                  style="float:right"
                  name="check-button"
                  switch
                >
                  <label style="font-size: 1rem">Pessoa Ativa</label>
                </b-form-checkbox>
              </b-form-group>
            </b-row>
            <!-- Nome e E-mail -->
            <b-row>
              <b-form-group
                label="Nome"
                class="col-6"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Nome"
                >
                  <b-form-input
                    v-model="form.nome"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="E-mail"
                class="col-md-6"
              >

                <validation-provider
                  #default="{ errors }"
                  rules="required|email"
                  name="E-mail"
                >
                  <b-form-input
                    v-model="form.email"
                    :state="(errors[0] || erroValidacao.email) ? false : null"
                    @blur="validaEmail"
                  />
                  <small class="text-danger">{{ errors[0] || erroValidacao.email }}</small>
                </validation-provider>
              </b-form-group>
            </b-row>
            <!-- Telefone de contato -->
            <b-row class="mb-1">
              <b-col>
                <telefone-celular
                  :value="form.telefoneContato"
                />
              </b-col>
            </b-row>

            <!-- Como chegou na Auditar/Quem indicou -->
            <b-row>
              <b-form-group
                label="Como chegou à Contabilidade?"
                class="col-6"
              >
                <div
                  v-for="(opcao, $index) in opcoesComoChegou"
                  :key="$index"
                  class="form-check form-check-inline"
                >
                  <b-form-checkbox
                    v-model="opcao.selecionada"
                    :value="true"
                    :unchecked-value="false"
                    :state="erroValidacao.comoChegou ? false : null"
                    style="margin-top: 0.7rem"
                    @change="selecionarOpcao(opcao, $index)"
                  >
                    {{ opcao.text }}
                  </b-form-checkbox>
                </div>
                <small class="text-danger d-block mt-1">{{ erroValidacao.comoChegou }}</small>
              </b-form-group>
              <b-col
                v-if="form.comoChegou !== null && form.comoChegou === 'indicacao'"
                cols="6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="'indicacao'"
                  :rules="form.comoChegou === 'indicacao' ? 'required' : ''"
                >
                  <!-- Componente para selecionar quem indicou o cliente -->
                  <indicacao-select
                    v-model="form.usuarioIndicacao"
                    :invalido="errors.length > 0"
                  />
                </validation-provider>
              </b-col>
              <b-form-group
                v-else-if="form.comoChegou !== null && form.comoChegou === 'outros'"
                class="col-6"
                label="Complemente (Opcional)"
              >
                <b-form-input
                  v-model="form.complementoOutros"
                />
              </b-form-group>
            </b-row>
            <!-- Empresas vinculadas a pessoa -->
            <b-row>
              <b-col cols="12">
                <empresa-select
                  v-model="form.empresas"
                  :multiple="true"
                  :label="'Empresa(s) com vínculo com esta pessoa'"
                />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab
            no-body
            title="Endereço"
          >
            <aba-endereco-pessoa
              v-model="form.endereco"
            />
          </b-tab>
        </b-tabs>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import api from '@/app-modulo/comercial/pessoa/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'Pessoas',
  components: {
    CadastroBase,
    ValidationProvider,
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    IndicacaoSelect: () => import('@/shared/components/indicacao-select/IndicacaoSelect.vue'),
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
    AbaEnderecoPessoa: () => import('./aba-endereco-pessoa/AbaEnderecoPessoa.vue'),
  },
  data() {
    return {
      required,
      form: {
        ativo: true,
        nome: '',
        email: '',
        telefoneContato: {
          telefoneWhatsApp: false,
          celularWhatsApp: false,
        },
        comoChegou: null,
        usuarioIndicacao: null,
        complementoOutros: '',
        empresas: null,
        endereco: {
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          uf: null,
          residenteExterior: false,
        },
      },
      opcoesComoChegou: [
        { selecionada: false, value: 'indicacao', text: 'Indicação' },
        { selecionada: false, value: 'facebook', text: 'Facebook' },
        { selecionada: false, value: 'instagram', text: 'Instagram' },
        { selecionada: false, value: 'google', text: 'Google' },
        { selecionada: false, value: 'outros', text: 'Outros' },
      ],
      immutableForm: {},
      state: 'none',
      erroValidacao: {
        email: '',
        comoChegou: '',
      },
    }
  },
  watch: {
    '$route.params.id': function onRouteIdChange(novoId, antigoId) {
      if (novoId && novoId !== antigoId) {
        this.state = 'editar'
        this.carregar(novoId)
      }
    },
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getPessoa(id)
        .then(payload => {
          this.form = payload.data
          const opcaoSelecionada = this.opcoesComoChegou.find(f => f.value === this.form.comoChegou)
          if (opcaoSelecionada) {
            opcaoSelecionada.selecionada = true
          }
        })
    },
    salvar() {
      this.erroValidacao.comoChegou = this.form.comoChegou !== null ? '' : 'Selecione uma opção'
      if (!this.erroValidacao.email && !this.erroValidacao.comoChegou) {
        return new Promise((resolve, reject) => {
          if (this.state === 'novo') {
            api.createPessoa(this.form)
              .then(() => {
                this.fechar()
                resolve('Pessoa cadastrada com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          } else {
            api.updatePessoa(this.form.id, this.form)
              .then(() => {
                this.fechar()
                resolve('Pessoa alterada com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          }
        })
      }
      return null
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'pessoas' })
      } else {
        this.$router.go(-1)
      }
    },
    validaEmail() {
      if (this.form.email !== '') {
        api.validaEmail(this.form.id, this.form.email)
          .then(payload => {
            if (payload.data) {
              this.erroValidacao.email = 'E-mail já existente'
            } else {
              this.erroValidacao.email = ''
            }
          })
      }
    },
    selecionarOpcao(opcao, index) {
      this.opcoesComoChegou.forEach(each => {
        if (each.value !== opcao.value) {
          // eslint-disable-next-line no-param-reassign
          each.selecionada = false
        }
      })
      this.form.comoChegou = opcao.selecionada ? opcao.value : null
      this.opcoesComoChegou[index].selecionada = opcao.selecionada

      this.form.complementoOutros = this.form.comoChegou !== 'outros' ? '' : this.form.complementoOutros
      this.form.usuarioIndicacao = this.form.comoChegou !== 'indicacao' ? null : this.form.usuarioIndicacao
    },
  },
}
</script>
